import React from "react";
import { ReactComponent as LogoMovistar } from "../assets/icons/logo.svg";
import CustomizedSteppers from "./Stepper";

const Header = ({ steps = [] }) => {

  return (
    <div className="flex flex-col space-y-4 font-telefonica">
      <div className="bg-white flex flex-row h-14 sm:h-20 px-24 xl:px-72 items-center justify-center sm:justify-between">
        <div className="flex flex-row justify-center w-1/6">
          <div className="h-7 w-9 sm:h-9  sm:w-12">
              <LogoMovistar />
          </div>
        </div>
        <div className="hidden sm:flex w-4/6 justify-self-center">
          <CustomizedSteppers steps={steps} />
        </div>
        <div className="hidden sm:flex w-1/6" />
      </div>
      <div className="flex sm:hidden">
        <CustomizedSteppers steps={steps} />
      </div>
    </div>
  );
};

export default Header;
